import api from "utils/api";

// Create a new student leader board entry
export const createStudentLeaderBoard = async (data) => {
  try {
    const response = await api.post("/student-leader-board", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all student leader board entries
export const getStudentLeaderBoards = async (params = {}) => {
  try {
    const response = await api.get("/student-leader-board", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get student leader board by ID
export const getStudentLeaderBoardById = async (id) => {
  try {
    const response = await api.get(`/student-leader-board?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get student leader board by month and year
export const getStudentLeaderBoardByMonthYear = async (month, year) => {
  try {
    const response = await api.get("/student-leader-board", {
      params: { month, year },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
